import React from 'react';
import PropTypes from 'prop-types';
import { LocalForm, Control, actions } from 'react-redux-form';
import SelectComponent from './SelectComponent';
import { getJobNameNumber } from './../helpers/job';
import { params as constants } from './../helpers';
import { commonPageInfo as commonPageHelpers } from '../helpers';


import {
  FormGroup,
  Col,
  ControlLabel,
  FormControl
} from 'react-bootstrap';

export default class DispatcherSelectorComponent extends React.Component {
  static propTypes = {
    jobsByName: PropTypes.shape({ name: PropTypes.string }).isRequired,
    params: PropTypes.object,
    activeTab: PropTypes.string.isRequired,
    dispatcherInfo: PropTypes.shape(
      {
        jobName: PropTypes.string,
        jobNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        numJobs: PropTypes.number
      }
    ).isRequired,
    onSubmit: PropTypes.func.isRequired
  };

  constructor() {
    super();
  }

  attachDispatch = (dispatch) => this.formDispatch = dispatch;

  checkJobName = (jobNames, currentJobName) => {
    if (!this.formDispatch) { return; }
    // auto select the first item in the list if no job has been selected yet
    if (jobNames.length >= 1 &&
      (currentJobName === '') &&
      (jobNames[0] !== currentJobName)) {
      this.formDispatch(actions.change('dispatch.jobName', jobNames[0]));
    }
  }

  getRecentJobNameNumbers(name) {
    if (name === undefined) {
      return [];
    }

    const params = this.props.params;
    const jobsByName = this.props.jobsByName;
    const allJobNames = Object.keys(jobsByName);
    if (allJobNames.length === 0)
      return [];

    if (name === 'all') {
      const allJobs = [];
      allJobNames.forEach(jobName => {
        const jobs = jobsByName[jobName] ? jobsByName[jobName] : [];
        allJobs.push(jobs.map(job => {
          const dispatchedBy = params[job.id] && Object.keys(params[job.id]).length > 0 ?
            params[job.id][constants.JENKINS_TRIGGER_BY] ||
            params[job.id][constants.DISPATCHEDBY] : '';
          return getJobNameNumber(job) + '-' +
            dispatchedBy.replace(new RegExp('_', 'g'), '-');
        }).slice(0, 5));
      }
      );
      if (allJobs.length > 0)
        return allJobs.reduce((acc, curr) => acc.concat(curr));
    }

    const jobs = jobsByName[name] ? jobsByName[name] : [];
    if (!jobs) {
      return [];
    }
    return jobs.map(job => {
      const dispatchedBy = params[job.id] && Object.keys(params[job.id]).length > 0 ?
        params[job.id][constants.JENKINS_TRIGGER_BY] ||
        params[job.id][constants.DISPATCHEDBY] : '';
      return getJobNameNumber(job) + '-' +
        dispatchedBy.replace(new RegExp('_', 'g'), '-');
    }
    );
  }

  getJobNames(jobs) {
    const dispatcherJobNames = jobs ? jobs.filter(x => x).map(j => j.name) : [];
    return [...new Set(dispatcherJobNames)];
  }

  getJobNameNumberFromInfo({ jobName, jobNumber }) {
    if (!jobName && !jobNumber) {
      return '';
    }

    return `${jobName}_${jobNumber}`;
  }

  getStateFromJobNameNumber(jobNameNumber) {
    const index = jobNameNumber.lastIndexOf('_');
    return {
      jobName: jobNameNumber.substring(0, index),
      jobNumber: jobNameNumber.substring(index + 1)
    };
  }

  render() {
    const {
      jobsByName,
      dispatcherInfo,
      onSubmit,
      activeTab
    } = this.props;

    const jobNames = Object.keys(jobsByName);
    const initialState = {
      jobName: dispatcherInfo.jobName ? dispatcherInfo.jobName : '',
      jobNumber: dispatcherInfo.jobNumber ? dispatcherInfo.jobNumber : '',
      numJobs: dispatcherInfo.numJobs ? dispatcherInfo.numJobs : 25
    };

    return (
      <div>
        <LocalForm
          id="dispatcher-selector-form"
          getDispatch={dispatch => this.attachDispatch(dispatch)}
          model="dispatch"
          onSubmit={onSubmit}
          onChange={onSubmit}
          initialState={initialState}
        >
          <FormGroup>
            <Col md={4}>
              <ControlLabel>
                Dispatcher Job:
              </ControlLabel>
              <Control.custom
                id="jobName-input"
                model="."
                component={SelectComponent}
                className="form-control"
                style={{ marginRight: '10px' }}
                mapProps={({ modelValue, onChange }) => {
                  this.checkJobName(jobNames, modelValue.jobName);
                  return {
                    options: jobNames,
                    noneOption: 'Select a Dispatcher...',
                    selected: modelValue.jobName,
                    onChange: d => {
                      const model = {
                        ...modelValue,
                        jobName: d,
                        jobNumber: ''
                      };
                      onChange(model);
                    }
                  };
                }}
              />
            </Col>
            <Col md={4}>
              <ControlLabel>
                Recent Dispatcher Jobs:
              </ControlLabel>
              <Control.custom
                disabled={activeTab === commonPageHelpers.FAILURE_TRENDS}
                id="jobNameNumber-input"
                model="."
                component={SelectComponent}
                className="form-control"
                style={{ marginRight: '10px' }}
                mapProps={({ modelValue, onChange }) => {
                  return {
                    options: modelValue.jobName !== '' ?
                      this.getRecentJobNameNumbers(modelValue.jobName) :
                      this.getRecentJobNameNumbers('all'),
                    noneOption: 'Select a recent Dispatcher...',
                    selected: this.getJobNameNumberFromInfo(modelValue),
                    onChange: d => {
                      let newJobName = this.getStateFromJobNameNumber(d).jobName;
                      if (newJobName === '')
                        newJobName = modelValue.jobName;
                      const model = {
                        ...modelValue,
                        jobName: newJobName,
                        jobNumber: this.getStateFromJobNameNumber(d).jobNumber
                      };
                      onChange(model);
                    }
                  };
                }}
              />
            </Col>
            <Col md={2}>
              <ControlLabel>Run Number:</ControlLabel>
              <Control.custom
                disabled={activeTab === commonPageHelpers.FAILURE_TRENDS}
                id="job-number-input"
                model="."
                component={FormControl}
                className="form-control"
                type="number"
                mapProps={({ modelValue, onChange }) => {
                  return {
                    value: modelValue.jobNumber,
                    onChange: d => onChange({
                      ...modelValue,
                      jobNumber: d.target.value
                    }),
                  };
                }}
              />
            </Col>
            <Col md={2}>
              <ControlLabel># of Recent Jobs</ControlLabel>
              <Control.custom
                id="number-jobs-input"
                model="."
                component={FormControl}
                className="form-control"
                type="number"
                mapProps={({ modelValue, onChange }) => {
                  return {
                    value: modelValue.numJobs,
                    onChange: d => onChange({
                      ...modelValue,
                      numJobs: d.target.value
                    }),
                  };
                }}
              />
            </Col>
          </FormGroup>
        </LocalForm>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// src/Components/DispatcherSelectorComponent.jsx